import axios from 'axios';
import config from './EnvironmentSwitcher';
import { getFhirToken } from './fhirAuth';

export const setupAxiosInterceptors = (handleTokenExpiration) => {
  // Create axios instances for different APIs
  const fhirAxios = axios.create({
    baseURL: `${config.fhirUrl}/fhir`,
    headers: {
      'Content-Type': 'application/fhir+json',
    }
  });

  const googleAxios = axios.create({
    baseURL: 'https://www.googleapis.com',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem('googleAccessToken')}`
    }
  });

  // Add request interceptor to update tokens if they change
  [fhirAxios, googleAxios].forEach(instance => {
    instance.interceptors.request.use(
      async (config) => {
        // Update tokens on each request in case they've changed
        if (String(config.baseURL || '').includes('/fhir')) {
          const token = await getFhirToken(true);
          if (token) config.headers['Authorization'] = `Bearer ${token}`;
        } else if (config.baseURL.includes('googleapis.com')) {
          config.headers['Authorization'] = `Bearer ${localStorage.getItem('googleAccessToken')}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    // Add response interceptors for token handling
    instance.interceptors.response.use(
      (response) => response,
      async (error) => {
        if (error.response?.status === 401) {
          // Token expired
          const isExpired = await handleTokenExpiration();
          if (isExpired) {
            // Clear any auth state/tokens
            localStorage.removeItem('mieFToken'); // adjust based on your token storage
            
            // Redirect to login
            window.location.href = '/login';
          }
        }
        return Promise.reject(error);
      }
    );
  });

  return { fhirAxios, googleAxios };
};

export default setupAxiosInterceptors;
